import { UserRolesValues } from "../data/UserRoles";

export default interface IGroupMembers {
    [key: string]: {
        displayName: string, 
        role: UserRolesValues
    }
}

export type IGroupMemberProperties = 'displayName' | 'role';

// This was created to because when new member get added and the page hot reloads
// they won't be in the memberData and it causes the whole app to crash.
export const GetMemberInfo = (
    memberKey: string | undefined, 
    memberData: IGroupMembers | null | undefined, 
    memberProperty: IGroupMemberProperties) => {
    return memberData && 
        memberKey && 
        memberKey in memberData && 
        memberData[memberKey] && 
        memberData[memberKey][memberProperty] ? 
        memberData[memberKey][memberProperty] : 
        'New Member';
}
